// src/services/api.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../apiEndPoints";
import { GENERATE_OTP, VALIDATE_OTP, GENERATE_USER } from "../apiEndPoints";

export const authApiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    generateOtp: builder.mutation({
      query: (mobile_number) => ({
        url: GENERATE_OTP,
        method: "POST",
        body: { mobile_number },
      }),
    }),
    validateOtp: builder.mutation({
      query: ({ id, otp }) => ({
        url: VALIDATE_OTP,
        method: "POST",
        body: { id, otp },
      }),
    }),
    generateUser: builder.mutation({
      query: (payload) => ({
        url: GENERATE_USER,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGenerateOtpMutation,
  useValidateOtpMutation,
  useGenerateUserMutation,
} = authApiSlice;
